var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCameraCapture(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 88,
    height: 88,
    viewBox: "0 0 88 88",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "shutter-b",
    d: "M40,0 C17.90861,0 0,17.90861 0,40 C0,62.09139 17.90861,80 40,80 C62.09139,80 80,62.09139 80,40 C80,17.90861 62.09139,0 40,0 Z"
  }), /*#__PURE__*/React.createElement("filter", {
    id: "shutter-a",
    width: "117.5%",
    height: "117.5%",
    x: "-8.8%",
    y: "-6.2%",
    filterUnits: "objectBoundingBox"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dy: 2,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1",
    stdDeviation: 2
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "shadowBlurOuter1",
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.5 0"
  })), /*#__PURE__*/React.createElement("path", {
    id: "shutter-c",
    d: "M48,13.5 L48,40.5 C48,42.984375 45.984375,45 43.5,45 L4.5,45 C2.015625,45 0,42.984375 0,40.5 L0,13.5 C0,11.015625 2.015625,9 4.5,9 L12.75,9 L13.903125,5.915625 C14.559375,4.1625 16.2375,3 18.1125,3 L29.878125,3 C31.753125,3 33.43125,4.1625 34.0875,5.915625 L35.25,9 L43.5,9 C45.984375,9 48,11.015625 48,13.5 Z M35.25,27 C35.25,20.79375 30.20625,15.75 24,15.75 C17.79375,15.75 12.75,20.79375 12.75,27 C12.75,33.20625 17.79375,38.25 24,38.25 C30.20625,38.25 35.25,33.20625 35.25,27 Z M32.25,27 C32.25,31.546875 28.546875,35.25 24,35.25 C19.453125,35.25 15.75,31.546875 15.75,27 C15.75,22.453125 19.453125,18.75 24,18.75 C28.546875,18.75 32.25,22.453125 32.25,27 Z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd",
    transform: "translate(4 2)"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "#000",
    filter: "url(#shutter-a)",
    xlinkHref: "#shutter-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#26436F",
    xlinkHref: "#shutter-b"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#FFF",
    transform: "translate(16 16)",
    xlinkHref: "#shutter-c"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCameraCapture);
export default __webpack_public_path__ + "static/media/camera_capture.2d88f32a57b997f222355055544a1c96.svg";
export { ForwardRef as ReactComponent };